<fw-dialog-simple [cancelButtonText]="data.cancelButtonText" [title]="data.title">
  <fw-dialog-content>
    <p class="vision-p2 error-dialog-title">{{data.contentText}}</p>
  </fw-dialog-content>
</fw-dialog-simple>
